import { Component, h, Prop } from '@stencil/core';
import Cookies from 'js-cookie';

// type for GTM injected liveChat tag functions
declare global {
  interface Window {
    setChatElements: () => void;
  }
}

@Component({
  tag: 'customer-chat',
  styleUrl: 'customer-chat.scss',
})
export class CustomerChat {
  /** Id to be used on desktop */
  @Prop() liveEngageId: string;
  /** Id to be used on mobile and tablet */
  @Prop() liveEngageIdMobile: string;

  // Manually trigger LP chat in footer as a fallback
  handleLiveEngageChatClick = () => {
    const element = document.querySelector('.sb-Footer .sb-FooterBodyList-item--chat.sb-Util-hidden--sm.sb-Util-hidden--md .sb-LiveEngage-chat > .LPMcontainer.LPMoverlay > span') as HTMLElement;
    if (element) {
      element.click();
    }
  };

  // update liveperson on component load if it exists
  componentDidLoad() {
    // if liveperson is already loaded, it might have missed parsing this element
    window?.setChatElements && window.setChatElements();
  }

  render() {
    const hvprCookie = Cookies.get('ttarp_override');
    const liveEngageId = this.liveEngageId ?? (hvprCookie === '855-792-1402' ? 'LP_DIV_1645056394123' : 'LP_DIV_RB_6687889599')
    const liveEngageIdMobile = this.liveEngageIdMobile ?? (hvprCookie === '858-792-1402' ? 'LP_DIV_1645056623189' : 'LP_DIV_RB_1501165477970')

    return (
      <div class="ghf-customerChat--default">
        <div class="img" title="Speech Bubble with Checkmark" />
        <div>
          <span class="ghf-customerChat-text">Chat with a Real Person</span>
          <span id={liveEngageId} class="sb-LiveEngage-chat ghf-customerChat-liveEngage--desktop" onClick={this.handleLiveEngageChatClick}>
            <p class="ghf-customerChat-storeText" aria-hidden="true">
              Chat Now
            </p>
          </span>
          <span id={liveEngageIdMobile} class="sb-LiveEngage-chat ghf-customerChat-liveEngage--mobile">
            <p class="ghf-customerChat-storeText" aria-hidden="true">
              Chat With a Real Person
            </p>
          </span>
        </div>
      </div>
    );
  }
}
